import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBet } from "../../../../redux/coinPrices/actions";
import ModalSelectBet from "./ModalSelectBet";
import "./styles.scss";
import { useTheme } from "../../../../hook/useThemes";
import { activeEventFathom } from "../../../../utils/utils";
import { useSearchParams } from "react-router-dom";

function ButtonBet(props) {
  const dispatch = useDispatch();
  const { lang, list_bet = [], default_bet = 1 } = useTheme();
  const valueBet = useSelector(
    (state: any) => state?.coinPrices?.bet || default_bet
  );
  const [open, setOpen] = useState<boolean>(false);

  const [searchParams] = useSearchParams();
  const demo = searchParams.get("demo") === "true";

  const LIST_VALUE = demo
    ? [0.1, 0.2, 0.5, 1, 2, 5, 10, 25, 50, 100, 200, 500, 1000]
    : list_bet || [
        0.1, 0.2, 0.5, 1, 2, 5, 10, 25, 50, 100, 200, 500, 1000, 5000,
      ];

  const len = list_bet?.length || 1;
  const MAX = demo ? 1000 : list_bet[len - 1] || 1000;
  const MIN = list_bet[0] || 0.1;

  const handleSetBet = (value: any) => {
    if (value && value !== "0") {
      dispatch<any>(setBet(value));
    }
  };

  const getIndex = (type: string, value: number) => {
    let result = value;
    if (type === "reduce") {
      for (let i = LIST_VALUE.length; i >= 0; i--) {
        if (LIST_VALUE[i] < value) {
          result = LIST_VALUE[i];
          break;
        }
      }
      return result;
    }
    for (let i = 0; i < LIST_VALUE.length; i++) {
      if (LIST_VALUE[i] > value) {
        result = LIST_VALUE[i];
        break;
      }
    }
    return result;
  };

  const handleClickButtonAction = (type?: string) => {
    const index = LIST_VALUE.findIndex((item) => `${item}` === `${valueBet}`);
    if (type === "reduce") {
      if (index === 0) {
        return;
      }
      if (index === -1) {
        const value = Number(valueBet);
        const result = getIndex("reduce", value);
        if (result < MIN) {
          return;
        }
        dispatch<any>(setBet(result));
        return;
      }
      const value = Number(LIST_VALUE[index - 1] || 1);
      if (value < MIN) {
        return;
      }
      dispatch<any>(setBet(value));
      return;
    }
    if (index === LIST_VALUE.length - 1) {
      return;
    }
    if (index === -1) {
      const value = Number(valueBet);
      const result = getIndex("", value);
      if (result > MAX) {
        return;
      }
      dispatch<any>(setBet(result));
      return;
    }
    const value = LIST_VALUE[index + 1];
    if (value > MAX) {
      return;
    }
    dispatch<any>(setBet(value));
    return;
  };

  return (
    <>
      <div
        className="wrap-button-bet"
        onClick={(e) => {
          e.stopPropagation();
          props.onClose?.();
        }}
      >
        <button
          className="button-bet-action button-bet-reduce"
          onClick={() => {
            handleClickButtonAction("reduce");
            activeEventFathom("StakeBtnDown");
          }}
        >
          -
        </button>

        <div className="button-bet-modal">
          <p className="label-bet">{lang?.bet || "BET"}</p>
          <button
            className="button-bet"
            onClick={() => {
              setOpen(true);
              activeEventFathom("StakeModal-Open");
            }}
          >
            ${Number(valueBet).toLocaleString("en-US")}
          </button>
        </div>

        <button
          className="button-bet-action button-bet-increase"
          onClick={() => {
            handleClickButtonAction();
            activeEventFathom("StakeBtnUp");
          }}
        >
          +
        </button>
      </div>

      <ModalSelectBet
        valueBetDefault={valueBet}
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={handleSetBet}
      />
    </>
  );
}

export default ButtonBet;
